import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@/components/button/Button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FilterModalProps {
  open: boolean;
  handleClose: () => void;
  filter: (filter: 'all' | 'mine' | 'dependents') => void;
}

export const FilterModal = ({
  open,
  handleClose,
  filter,
}: FilterModalProps) => {
  const { t } = useTranslation('filter');
  const [selectedValue, setSelectedValue] = useState<
    'all' | 'mine' | 'dependents'
  >('all');

  const handleRadioButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedValue(event.target.value as 'all' | 'mine' | 'dependents');
  };

  const handleApplyFilter = () => {
    filter(selectedValue);
    handleClose();
  };

  const handleClearFilters = () => {
    setSelectedValue('all');
    filter('all');
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="filter-dialog-title"
    >
      <DialogTitle id="filter-dialog-title">{'Filtrar'}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <FormControl>
          <RadioGroup value={selectedValue} onChange={handleRadioButtonChange}>
            <FormControlLabel
              value="all"
              control={<Radio />}
              label={t('all_the_appointments')}
            />
            <FormControlLabel
              value="mine"
              control={<Radio />}
              label={t('only_my_appointments')}
            />
            <FormControlLabel
              value="dependents"
              control={<Radio />}
              label={t('only_my_dependents')}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions
        sx={{ padding: 3, display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <Button title={t('apply')} onClick={handleApplyFilter} />
        <Button outlined title={t('clear')} onClick={handleClearFilters} />
      </DialogActions>
    </Dialog>
  );
};
